import {FormattedDate, getWeekMonthbetweenDates,
    getWeekbetweenDates, getMonthbetweenDate} from './CalendarFucntions'

const base_raster_url = 'https://services.sentinel-hub.com/ogc/fis/'
const instance_id = '3dabb94a-aaf7-4ca5-8c2f-d0289538bbdf'
let date = new Date();
let fromdate = new Date()
fromdate.setDate(fromdate.getDate()-365*4);
const formattedToDate = FormattedDate(date);
const formattedFromDate = FormattedDate(fromdate);
export const index_url = `${base_raster_url}${instance_id}`
const  crs = 'CRS%3A84'
const time = `${formattedFromDate}/${formattedToDate}`
// console.log(time)
const resolution= '10m'
const maxCloudcover = 10
const bins = 10
export function Queryparamsindex (selected_index, poly_str){
    let params = {
        LAYER: selected_index,
        CRS: crs,
        TIME: time,
        GEOMETRY: poly_str,
        resolution: resolution,
        MAXCC: maxCloudcover,
        BINS:bins,
    }
    return params
}

export const YearMonthMap = () => {
    const Year_month = getMonthbetweenDate(fromdate,date)
    return Year_month
}









//   export const year_month_week = getYearWeekMonthDates(fromdate,date)
    

